import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { filterTableDataAPI } from "services/CRUDServices"
import { getUrls } from "services/api.enums"

export const filterFish: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "fish-managemnt",
  async (body: any) => {
    // delete body.pageNumber
    const data = await filterTableDataAPI(
      getUrls.fishManagement,
      body.pageNumber,
      { ...body, pageNumber: undefined, pageSize: undefined },
      true,
      10,
      false
    )

    return data.data.payload
  }
)

const initialState: any = {
  fishData: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
}

const FishSlice = createSlice({
  initialState: initialState,
  name: "fish-managemnt",
  reducers: {
    clearFish: (state) => {
      state.fishData = []
    },
    setFishFilter: (state, action) => {
      state.filter = action.payload
    },

  },
  extraReducers: {
    [filterFish.fulfilled as any]: (state, action) => {
      state.fishData = action.payload
      state.fetchpost = false
    },
    [filterFish.pending as any]: (state) => {
      state.fetchpost = true
    },
    [filterFish.rejected as any]: (state) => {
      state.fetchpost = false
      state.errorMessage = "wrong"
    },
  },
})

export const { setFishFilter, clearFish } =
  FishSlice.actions
export default FishSlice.reducer
